import { render, staticRenderFns } from "./Sesiones.vue?vue&type=template&id=2fe0434e&"
import script from "./Sesiones.vue?vue&type=script&lang=js&"
export * from "./Sesiones.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports